module.exports = __webpack_public_path__ + "img/Delete-Group-Deal.67557429.svg";